import React from "react";
import ReactDOM from "react-dom/client"; // Note the new import for React 18
import MainApp from "./main";
import registerServiceWorker from "./serviceWorker";

// Create a root using ReactDOM.createRoot (React 18)
const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

// Render your main component directly
root.render(<MainApp />);

// Optionally register the service worker if needed
registerServiceWorker();

// Fast Refresh is built into CRA 5, so explicit hot module replacement code is no longer required.
